import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import StepperUtil from "../../UtilComponents/StepperUtil";
import AccountBalanceUtil from "../../UtilComponents/AccountBalanceUtil";
import AccountSumUtils from "../../UtilComponents/AccountSumUtils";
import ReadAndMore from "../../UtilComponents/ReadAndMore";
import ChartUtil from "../../UtilComponents/ChartUtil";
import CryptoTableUtil from "../../UtilComponents/CryptoTableUtil";
import NewsAndUpdateUtil from "../../UtilComponents/NewsAndUpdateUtil";
import useAuth from "../../../hooks/useAuth";
import UpdateCarousel from "./UpdateCarousel";
import CarouselUtil from "../../UtilComponents/CarouselUtil";
import CryptoInfo from "../../UtilComponents/CryptoInfo";

export default function UDLandingUi({ pathname }) {
	const profit = "600.00";
	const loss = "200.00";
	const recentInvestment = "400.00";
	const { auth } = useAuth();

	console.log(auth);

	return (
		<Box
			variant="section"
			sx={{
				py: 4,
				my: "2rem",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				textAlign: "center",
			}}>
			<StepperUtil />
			<AccountSumUtils />
			<AccountBalanceUtil />
			<Box
				sx={{
					width: "100%",
					mt: 2,
					display: "flex",
					flexDirection: { xs: "column", lg: "row" },
					alignItems: "center",
					gap: 2,
				}}>
				<CarouselUtil />
				<CryptoInfo />
			</Box>
			<Box
				sx={{
					width: { xs: "100%", md: "80%" },
					// bgcolor: "green",
					mt: 4,
					display: "flex",
					flexDirection: { xs: "column", lg: "row" },
					alignItems: "center",
				}}>
				<UpdateCarousel />
				<NewsAndUpdateUtil />
			</Box>
			{/* <Typography variant="h5" sx={{ mt: "1rem" }}>
				Actively Traded Digital Assets.
			</Typography>
			<ChartUtil /> */}
		</Box>
	);
}

UDLandingUi.propTypes = {
	pathname: PropTypes.string.isRequired,
};
